module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-fixed-button mt-color-white",
    class: ['mint-fixed-button--' + _vm.position, 'mint-fixed-button--' + _vm.type, 'mt-bg-' + _vm.type],
    style: (_vm.computeStyle),
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "mint-fixed-button--plus",
    style: (_vm.computePlusStyle)
  }, [_c('div', {
    staticClass: "mint-fixed-button--plus_h",
    style: (_vm.computePlusItemStyle)
  }), _c('div', {
    staticClass: "mint-fixed-button--plus_v",
    style: (_vm.computePlusItemStyle)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ac568ca","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/fixed-button/src/fixed-button.vue
// module id = 362
// module chunks = 0